<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Refactoring kompletní softwareové infrastruktury z velmi starého, funkcionálně orientovaného
        PHP kódu zahrnující mimo jiné:
      </p>

      <ul class="mt-3">
        <li>
          e-shop – backend i frontend, pro backend byl zvolen poměrně mladý framework Phalcon, frontend
          je postaven na šablonovacím systému Phalconu VOLT a knihovně jQuery, responzivní design je zajištěn
          CSS styly za využití SASS preprocesoru
        </li>
        <li>
          interní administrace pro správu webu, objednávek, zakázek, zákazníků, zboží, skladů,
          fakturace… – postavena opět na frameworku Phalcon a knihovně jQuery
        </li>
        <li>
          skladové a expediční terminály – speciální dotekové terminály používané ve skladech pro expedici
          objednávek, naskladnění nového zboží, nepřijatých zásilek a vratek, inventury apod.; frontend běžící
          na terminálech je vytvořen v Pythonu z důvodu ovládání periférií (tiskárny skladových a expedičních
          etiket, čtečky čárových kódů, váhy apod.), backend obsluhuje opět framework Phalcon a speciální
          JavaScriptový prototypový event-driven framework psaný na míru, mezi jehož funkce patří například
          zprostředkování předávání dat mezi frontend aplikací a serverem, zprostředkování obsluhy terminálu (GUI),
          paralelní zpracování tisku s meziuložením tiskových dat do lokální databáze terminálu (print cache),
          nastavení aplikace a periférií apod. O obsluhu DOMu se opět stará jQuery
        </li>
        <li>
          podpůrné systémy jako například exporty dat pro různé vyhledávače, propojení s účetními systémy,
          server-side tasky pro zpracování různých potřebných událostí např. zpracování plateb u platebních
          společností, odesílání emailů a příloh, odesílání SMS, odesílání dat přepravním společnostem a podobně
        </li>
      </ul>

      <p class="mt-3">
        E-shop je provozován na adrese
        <a href="//svetbot.cz" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>svetbot.cz</span>
        </a>
      </p>
    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>

  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "SvetBot",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'SvětBot – největší internetový prodejce obuvi a doplňků',
        images: [
          {
            preview: '/img/refs/svetbot/01_prv.png',
            src: '/img/refs/svetbot/01.png',
            description: 'Titulní stránka e-shopu',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/02_prv.png',
            src: '/img/refs/svetbot/02.png',
            description: 'Kolekce obuvi s filtry',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/03_prv.png',
            src: '/img/refs/svetbot/03.png',
            description: 'Detail produktu',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/04_prv.png',
            src: '/img/refs/svetbot/04.png',
            description: 'Košík',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/05_prv.png',
            src: '/img/refs/svetbot/05.png',
            description: 'Doručení a platba',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/06_prv.png',
            src: '/img/refs/svetbot/06.png',
            description: 'Skladový terminál - úvodní obrazovka',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/07_prv.png',
            src: '/img/refs/svetbot/07.png',
            description: 'Skladový terminál - seznam položek s virtuální dotykovou klávesnicí',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/08_prv.png',
            src: '/img/refs/svetbot/08.png',
            description: 'Skladový terminál - inventura',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/09_prv.png',
            src: '/img/refs/svetbot/09.png',
            description: 'Skladový terminál - expedice podle dopravců',
            alt: ''
          },
          {
            preview: '/img/refs/svetbot/10_prv.png',
            src: '/img/refs/svetbot/10.png',
            description: 'Skladový terminál - expedice objednávky ze skladu',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['setItems', 'showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  a i {
    font-size: 12px!important;
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 1px;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>